import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CategoryClient, CategoryDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-category-control',
  templateUrl: './category-control.component.html',
  styleUrls: ['./category-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CategoryControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CategoryControlComponent),
      multi: true,
    }
  ]
})
export class CategoryControlComponent extends BaseAutocompleteControl<CategoryDto> implements OnInit {

  // Category-specific input
  @Input() onlyParent: boolean = false;

  constructor(
    private categoryClient: CategoryClient,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Fetch categories from API
   */
  protected fetchItems(searchValue: string): Observable<CategoryDto[]> {
    if (this.onlyParent) {
      const cacheKey = `category_parent_search_${searchValue}`;
      return this.cache.wrap(cacheKey, this.categoryClient.getCategoryParentByKeySearch(searchValue).pipe(
        map(items => items || [])
      ));
    } else {
      const cacheKey = `category_search_${searchValue}`;
      return this.cache.wrap(cacheKey, this.categoryClient.getCategoryByKeySearch(searchValue).pipe(
        map(items => items || [])
      ));
    }
  }

  /**
   * Get display value for category
   */
  getDisplayValue(item: CategoryDto | null): string {
    return item?.ten || '';
  }

  /**
   * Check if value is a valid CategoryDto instance
   */
  protected isValidItem(value: any): boolean {
    return value instanceof CategoryDto;
  }
}
